module.exports = "/_next/static/images/e3309cbb577a02424a2e2b16b340264b-card-lg.png";